// useUpgradeIntent.js
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useUpgradeIntent() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const price = searchParams.get('package');
    if (price && !sessionStorage.getItem('upgrade_intent')) {
      sessionStorage.setItem('upgrade_intent', price);
    }
  }, [searchParams]);
}
